import { Moment, tz } from 'moment-timezone'
import React from 'react'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'

import { shortDateWithDayOfWeek, longDateTimeWithSeconds } from 'helpers/formatters'

import { color } from 'styles/colors'

type Props = {
  eventOccurredAt: number
  timeZone: string
  withoutSeconds?: boolean
  showDayRthCallback: (day: Moment) => void
}

const AlertEventTime = ({ eventOccurredAt, timeZone, withoutSeconds = false, showDayRthCallback }: Props) => {
  const timeWithTimeZone = tz(Number(eventOccurredAt) * 1000, timeZone)

  const presentDate = tz(timeZone)
  const isOccurredWithInRange = presentDate.diff(timeWithTimeZone, 'days') <= 30

  const onDayRthClickCallback = () => {
    if (isOccurredWithInRange) {
      showDayRthCallback(timeWithTimeZone)
    }
  }

  return (
    <S.AlertEventTime enabled={!!isOccurredWithInRange} isOccurredWithInRange={isOccurredWithInRange} onClick={onDayRthClickCallback}>
      {withoutSeconds ? shortDateWithDayOfWeek(timeWithTimeZone) : longDateTimeWithSeconds(timeWithTimeZone)}

      {isOccurredWithInRange && <S.DisplayDayRthIcon className="icon-display-day-rth" aria-label="display day rth" />}
    </S.AlertEventTime>
  )
}

export default AlertEventTime

const S = {
  AlertEventTime: styled(KeyboardAccessible).withConfig({
    shouldForwardProp: (prop) => !['isOccurredWithInRange'].includes(prop)
  })<{ isOccurredWithInRange: boolean }>`
    display: inline-block;
    color: ${color('primaryText')};
    pointer-events: ${({ isOccurredWithInRange }) => isOccurredWithInRange ? 'auto' : 'none'};

    &:hover {
      color: ${color('anchorHover')};
    }
  `,
  DisplayDayRthIcon: styled.i`
    display: inline;
    padding-left: 5px;
  `
}
